import { render, staticRenderFns } from "./LineageBI.vue?vue&type=template&id=70d9c4de&scoped=true&lang=pug"
import script from "./LineageBI.vue?vue&type=script&lang=js"
export * from "./LineageBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d9c4de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d9c4de')) {
      api.createRecord('70d9c4de', component.options)
    } else {
      api.reload('70d9c4de', component.options)
    }
    module.hot.accept("./LineageBI.vue?vue&type=template&id=70d9c4de&scoped=true&lang=pug", function () {
      api.rerender('70d9c4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/LineageBI.vue"
export default component.exports